// Runs before analytics initializes. Embeds live inside other people's pages, so they
// skip the cookie notice and ad tags, and keep analytics in memory instead of cookies.
export const isEmbedDocument = typeof window !== 'undefined' && /^\/embed\/[^/]+\/?$/.test(window.location.pathname);
